export default __webpack_public_path__ + "static/media/uniprime-logo.e2634210.png";